
import React from "react";
import { Document, Page, Text, View, StyleSheet, Image, Font } from "@react-pdf/renderer";

const parseHtmlContent = (htmlContent) => {
    const div = document.createElement("div");
    div.innerHTML = htmlContent;

    return Array.from(div.childNodes).map((node, index) => {
        if (node.nodeName === "U") {
            // Handle underlined text
            return (
                <Text key={index} style={styles.underlined}>
                    {node.textContent}
                </Text>
            );
        }

        if (node.nodeName === "P" && node.innerHTML.includes("<u>")) {
            // Handle paragraphs with underlined content
            return (
                <View key={index}>
                    <Text style={styles.underlined}>
                        {node.textContent.trim()}
                    </Text>
                    <View style={{ marginBottom: 10 }} /> {/* Add space after */}
                </View>
            );
        }

        if (node.nodeName === "OL") {
            return (
                <View key={index} style={{ marginBottom: 10 }}>
                    {Array.from(node.childNodes).map((li, idx) => (
                        <View key={idx} style={styles.listItemContainer}>
                            <Text style={styles.listItemNumber}>{`${idx + 1}.`}</Text>
                            <Text style={styles.listItemText}>{li.textContent.trim()}</Text>
                        </View>
                    ))}
                </View>
            );
        }

        if (node.nodeName === "UL") {
            return (
                <View key={index} style={{ marginBottom: 10 }}>
                    {Array.from(node.childNodes).map((li, idx) => (
                        <View key={idx} style={styles.listItemContainer}>
                            <Text style={styles.listItemNumber}>•</Text>
                            <Text style={styles.listItemText}>{li.textContent.trim()}</Text>
                        </View>
                    ))}
                </View>
            );
        }


        return (
            <Text key={index} style={styles.text}>
                {node.textContent.trim()}
            </Text>
        );
    });
};








const TaxInvoicePDF = ({ proformainvoice, proformainvoiceNotes, taxinvoiceTerms, companyDetails,currency }) => {
    console.log("ProformaInvoice Data:", proformainvoice);
    if (!proformainvoice) {
        return <Text>Loading...</Text>; // Handle cases where quotation is null/undefined
    }
    console.log(Font);

    Font.register({
        family: "Arial",
        src: "/fonts/arial/arial.ttf",
    });

    console.log("Registered Fonts:", Font.getRegisteredFontFamilies());

    const calculateVAT = (amount) => {
        if (currency === "USD") {
            return 0; // VAT is 0 if the currency is USD
        }
        return parseFloat((amount * 0.05).toFixed(2));
    };
    const vatAmount = calculateVAT(proformainvoice.amount);
    return (
        <Document>
            <Page style={styles.page}>
                {/* Header Section */}
                <View style={styles.header}>
                    <View>
                        <Text style={styles.companyName}>{companyDetails?.company_name || 'Systech Technologies'}</Text>{"\n"}
                        <Text style={styles.companyDetails}>
                            {companyDetails?.phone} <br />{"\n"}
                            {companyDetails?.email} <br />{"\n"}
                            <Text>Dar Al Nahda Building, Office 307{"\n"}P.O Box 91607</Text>{"\n"}
                        </Text>
                    </View>
                    <View style={styles.topRight}>
                        <Image
                            src="/images/655c8bbb23be8.png" // Provide the image source
                            style={styles.image}
                        />
                        <Text style={styles.proformainvoiceTitle}>Tax Invoice</Text>
                    </View>
                </View>


                <View style={styles.detailsSection}>
                    {/* Left Column */}
                    <View style={styles.column}>
                        <View style={styles.labelValueRow}>
                            <Text style={styles.label}>Project:</Text>
                            <Text style={styles.value}>{proformainvoice.quotation?.project?.name || ""}</Text>
                        </View>
                        <View style={styles.labelValueRow}>
                            <Text style={styles.label}>Document No:</Text>
                            <Text style={styles.value}>{proformainvoice.tax_invoice?.ref_no || ""}</Text>
                        </View>
                        <View style={styles.labelValueRow}>
                            <Text style={styles.label}>Date:</Text>
                            <Text style={styles.value}>
                                {proformainvoice.created_at
                                    ? new Date(proformainvoice.tax_invoice?.created_at).toLocaleDateString().replace(/\//g, "-")
                                    : ""}
                            </Text>
                        </View>
                    </View>

                    {/* Right Column */}
                    <View style={styles.column}>
                        <View style={styles.labelValueRow}>
                            <Text style={styles.label}>Customer:</Text>
                            <Text style={styles.value}>{proformainvoice.quotation?.project?.client?.name || ""}</Text>
                        </View>
                        <View style={styles.labelValueRow}>
                            <Text style={styles.label}>Address:</Text>
                            <Text style={styles.value}>{proformainvoice.quotation?.project?.client?.address || ""}</Text>
                        </View>
                        <View style={styles.labelValueRow}>
                            <Text style={styles.label}>Contact Phone:</Text>
                            <Text style={styles.value}>{proformainvoice.quotation?.project?.client?.contacts[0]?.phone || ""}</Text>
                        </View>
                        <View style={styles.labelValueRow}>
                            <Text style={styles.label}>Contact Email:</Text>
                            <Text style={styles.value}>{proformainvoice.quotation?.project?.client?.contacts[0]?.email || ""}</Text>
                        </View>
                    </View>
                </View>


                {/* Table Section */}
                <View style={styles.table}>
                    {/* Table Header */}
                    <View style={styles.tableRow}>
                        <Text style={[styles.tableHeader, { width: "5%" }]}>No</Text>
                        <Text style={[styles.tableHeader, { width: "20%" }]}>Product</Text>
                        <Text style={[styles.tableHeader, { width: "40%" }]}>Description</Text>
                        <Text style={[styles.tableHeader, { width: "10%" }]}>Qty</Text>
                        <Text style={[styles.tableHeader, { width: "10%" }]}>Rate</Text>
                        <Text style={[styles.tableHeader, { width: "10%" }]}>VAT(5%)</Text>

                        <Text style={[styles.tableHeader, { width: "15%" }]}>Amount</Text>
                    </View>

                    {/* Table Rows */}
                    {proformainvoice.quotation?.product_item_details?.length > 0 ? (
                        proformainvoice.quotation.product_item_details.map((item, index) => (

                            <View key={index} style={styles.tableRow}>
                                <Text style={[styles.tableCell, { width: "5%" }]}>{index + 1}</Text>
                                <Text style={[styles.tableCell, { width: "20%" }]}>
                                    {item.product?.product_name || ""}
                                </Text>
                                <Text style={[styles.tableCell, { width: "40%" }]}>
                                    {item.item_description || ""}
                                </Text>
                                <Text style={[styles.tableCell, { width: "10%" }]}>
                                    {item.quantity || ""}
                                </Text>
                                <Text style={[styles.tableCell, { width: "10%" }]}>
                                    {item.price || ""}
                                </Text>
                                <Text style={[styles.tableCell, { width: "10%" }]}>
                                    {calculateVAT(item.price) || ""}
                                </Text>
                                <Text style={[styles.tableCell, { width: "15%" }]}>
                                    {(item.subtotal)}
                                </Text>
                            </View>
                        ))
                    ) : (
                        <Text style={{ textAlign: "center", fontStyle: "italic" }}>
                            No items available
                        </Text>
                    )}
                </View>


                   <View style={styles.footer}>
                         {proformainvoice.discount_amount && proformainvoice.discount_amount > 0 && (
                           <Text>
                             <Text style={{ fontWeight: "bold" }}>One Time Discount: </Text>
                             {proformainvoice.discount_amount || ""}
                           </Text>
                         )}
                         <Text>
                           <Text style={{ fontWeight: "bold" }}>Total Amount:</Text> {proformainvoice.tax_invoice?.total_amount || ""}
                         </Text>
                         <Text>
                           <Text style={{ fontWeight: "bold" }}>Invoiced Amount :</Text> {proformainvoice.tax_invoice?.amount_received || ""}
                         </Text>
                         <Text>
                           <Text style={{ fontWeight: "bold" }}>Total Vat (5%):</Text> {proformainvoice.tax_invoice?.vat_amount || ""}
                         </Text>
                     
                         <Text>
                           <Text style={{ fontWeight: "bold" }}>Total Inc. VAT :</Text> {proformainvoice.tax_invoice?.total_with_vat || ""}
                         </Text>
               
                      
                       </View>

                {taxinvoiceTerms && (
                    <View style={styles.terms}>
                        {parseHtmlContent(taxinvoiceTerms)}
                    </View>
                )}
                {/* Signature Section */}
                <View style={styles.signfooter}>
                    <View style={styles.signatureSection}>
                        {[ "Stamp", "Authorized"].map((role, index) => (
                            <View key={index} style={styles.signatureBlock}>
                                <Text>--------------------------</Text> {/* Placeholder line */}
                                <Text>{role}</Text>
                                <Text>{role === "Stamp" ? "" : "Signature"}</Text>
                            </View>
                        ))}
                    </View>
                </View>
            </Page>
        </Document>
    );
};

export default TaxInvoicePDF;

const styles = StyleSheet.create({
    page: {
        padding: 30,
        fontFamily: "Arial",
        fontSize: 10,
    },
    header: {
        flexDirection: "row",
        justifyContent: "space-between",
        marginBottom: 15,
        borderBottom: ".1px solid #ddd",
        //   paddingBottom: 7,
    },
    companyName: {
        fontSize: 14,
        fontWeight: "bold",
        color: "#415094",
        fontFamily: 'Arial',
    },
    companyDetails: {
        fontSize: 10,
        marginTop: 2,
        color: "#415094",
        lineHeight: 1.3
    },
    image: {
        objectFit: "contain",
        marginBottom: "10px",
        maxWidth: "160px",
        maxHeight: "80px",
    },
    proformainvoiceTitle: {
        fontSize: 15,
        fontWeight: "bold",
        color: "#415094",
        marginLeft: 79,
        lineHeight: .4,
        marginBottom: 20,
    },
    detailsSection: {
        flexDirection: "row",
        justifyContent: "space-between",
        //   marginVertical: 10,
        //   borderBottom: "1px solid #ddd",
        paddingBottom: 5,
        lineHeight: 1
    },
    column: {
        width: "35%", // Ensure each column takes up half the width with some margin for spacing
    },
    labelValueRow: {
        flexDirection: "row",
        marginBottom: 2, // Space between rows
    },
    label: {
        width: 80, // Fixed width for labels to align data
        fontWeight: "bold",
        fontSize: 10,
        textAlign: "left",
    },
    value: {
        flex: 1, // Allow data to take the remaining space
        fontSize: 10,
        textAlign: "left",
    },
    table: {
        width: "100%",
        marginTop: 40,
        // borderWidth: 1,
        borderColor: "#ddd",
        borderCollapse: "collapse",
    },
    tableRow: {
        flexDirection: "row",
        borderBottomWidth: 1,
        borderColor: "#ddd",
        paddingVertical: 5,
    },
    tableHeader: {
        fontSize: 10,
        fontWeight: "bold",
        textAlign: "center",
        // borderRightWidth: 1,
        borderColor: "#ddd",
        padding: 5,
    },
    tableCell: {
        fontSize: 10,
        textAlign: "center",
        // borderRightWidth: 1,
        borderColor: "#ddd",
        padding: 5,
    },

    footer: {
        marginTop: 35,
        textAlign: "right",
        fontSize: 10,
        lineHeight: 1.8,
        fontWeight: "bold",

    },
   
    
     
    terms: {
        fontSize: 12,
        marginTop: 35,
        textAlign: "left",
        marginBottom: 80,
        // padding:5 ,10


    },
    // termsListItem: {
    //   fontSize: 9,  // Adjust the font size as necessary
    //   marginTop: 5,  // Adjust spacing between items if necessary
    //   textAlign: "left",  // Ensure text is left-aligned
    //   lineHeight: 1.5,  // Adjust line height for readability
    // },

    // underlined: {
    //   textDecoration: "underline",
    // },
    underlined: {
        textDecoration: "underline", // Ensures the text is underlined
        fontSize: 12,
        fontWeight: "bold", // Optional, if you want bold underlined text
        marginBottom: 5,
    },
    listItem: {
        fontSize: 10,
        marginBottom: 5,
        textAlign: "left",
        lineHeight: 1,
    },
    text: {
        fontSize: 10,
        marginBottom: 10,
        lineHeight: 1,
    },
    listItemContainer: {
        flexDirection: "row",
        alignItems: "flex-start",
        marginBottom: 5, // Space between list items
    },
    listItemNumber: {
        width: 15, // Adjust the width to control number alignment
        textAlign: "right",
        marginRight: 5, // Space between the number and the text
        fontSize: 10,
    },
    listItemText: {
        flex: 1, // Ensures the text wraps correctly
        fontSize: 10,
        textAlign: "left",
        lineHeight: 1, // Adjust line spacing for readability
    },
    signfooter: {
        position: "absolute",
        bottom: 30, // Ensures it stays at the bottom of the page
        left: 0,
        right: 0,
        width: "100%",
      },
    signatureSection: {
        flexDirection: "row",
        justifyContent: "space-around",
        marginTop: 80,
    },
    signatureBlock: {
        alignItems: "center",
    },
    signatureLine: {
        width: "100%",
        borderBottom: "1px solid #000",
        marginBottom: 5,
    },
});
